import LayoutWithoutSidebar from '../ui/LayoutWithoutSidebar';
import SideLogo from '../features/profilecreation/SideLogo';

import ProfileInput from '../features/profilecreation/ProfileInput';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

function CreateProfile() {
    const { state } = useContext(AuthContext);
    const { user } = state;
    const navigate = useNavigate();

    useEffect(() => {
        if (user.length > 0) {
            navigate('/', { replace: true });
        }
    }, [user, navigate]);

    return (
        <div className="flex justify-between w-[65%] mx-auto mt-14 mb-3 min-h-[calc(100vh-15vh)]  ">
            <div className=" justify-self-center w-[80%] ">
                <ProfileInput />
            </div>

            <SideLogo />
        </div>
    );
}

export default CreateProfile;
